import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrVerificationDocReviewStatus.ts
var t = () => e("verificationDocReviewStatus");
//#endregion
export { t as useTrVerificationDocReviewStatus };
